import React from 'react';
import { S11Awards, S11AwardsProps, MilanGradientColors, MilanBackgroundColors } from '@milanlaser/mlcomponents';
import { PaddingSize, paddingMap } from '../../utils/builderPaddingOptions';
import { processBackgroundAndGradientColorMap } from '../../utils/builder.utils';

interface S11AwardsArgs extends Omit<S11AwardsProps, 'backgroundGradient' | 'backgroundColor' | 'cardBackgroundColor'> {
  desktopPaddingTop: PaddingSize;
  desktopPaddingBottom: PaddingSize;
  mobilePaddingTop: PaddingSize;
  mobilePaddingBottom: PaddingSize;
  backgroundGradient: MilanGradientColors | 'None';
  backgroundColor?: string;
  cardBackgroundColor?: string;
}

export function S11AwardsSection(s11Props: S11AwardsArgs) {
  const {
    desktopPaddingTop,
    desktopPaddingBottom,
    mobilePaddingTop,
    mobilePaddingBottom,
    backgroundGradient,
    backgroundColor,
    cardBackgroundColor,
    ...restProps
  } = s11Props;

  const topPaddingClasses = `mcl-pt-${paddingMap[mobilePaddingTop]} lg:mcl-pt-${paddingMap[desktopPaddingTop]}`;
  const bottomPaddingClasses = `mcl-pb-${paddingMap[mobilePaddingBottom]} lg:mcl-pb-${paddingMap[desktopPaddingBottom]}`;

  const processedBackgroundGradient = backgroundGradient === 'None' ? '' : backgroundGradient;
  const processedBackgroundColor = backgroundColor === 'None' ? '' : backgroundColor;
  const processedCardBackgroundColor = cardBackgroundColor === 'None' ? '' : cardBackgroundColor;

  const modifiedProps = {
    ...restProps,
    className: `mcl-mx-auto mcl-max-w-7xl ${topPaddingClasses} ${bottomPaddingClasses}`,
    backgroundColor: processedBackgroundColor as MilanBackgroundColors,
    backgroundGradient: processedBackgroundGradient as MilanGradientColors,
    cardBackgroundColor: processedCardBackgroundColor as MilanBackgroundColors,
  };

  const backgroundColorClass = processBackgroundAndGradientColorMap({
    backgroundColor: (processedBackgroundColor || 'None') as MilanBackgroundColors | 'None',
    gradientColor: (processedBackgroundGradient || 'None') as MilanGradientColors | 'None',
  });

  return (
    <div className={`${backgroundColorClass}`}>
      <S11Awards {...modifiedProps} />
    </div>
  );
}
